import { Auth } from "aws-amplify";
import axios from "axios";

export const getUserInfo = async (userId: string | undefined) => {
    if (userId) {
        const apiBaseUrl = process.env.REACT_APP_IDWAL_API_URL;
        const currentSession = await Auth.currentSession();
        const jwtToken = currentSession.getIdToken().getJwtToken();

        const api = axios.create({
            baseURL: apiBaseUrl,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${jwtToken}`
            }
        });

        try {
            const apiResponse = await api.get(`/Users/${userId}/Info`);

            const userInfo = apiResponse.data.data;

            return userInfo;
        } catch (error) {
            return null;
        }
    }

    return null;
};